module.exports = __webpack_public_path__ + "img/game-developers.9fa535bc.png";